export default __webpack_public_path__ + "static/media/table-tablet@3x.f48b8e06.png";